import React, { useState } from 'react';
import Button from '../atoms/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import book1_1 from '../../assets/images/1_1.JPG';
import book1_2 from '../../assets/images/1_2.JPG';
import book1_3 from '../../assets/images/1_3.JPG';
import book1_4 from '../../assets/images/1_4.JPG';
import book1_5 from '../../assets/images/1_5.JPG';
import book1_6 from '../../assets/images/1_6.JPG';
import book1_7 from '../../assets/images/1_7.JPG';
import book1_8 from '../../assets/images/1_8.JPG';
import book1_9 from '../../assets/images/1_9.JPG';
// import book1_10 from '../../assets/images/1_10.JPG';
// import book1_11 from '../../assets/images/1_11.JPG';
import book1_12 from '../../assets/images/1_12.png';
import book1_13 from '../../assets/images/1_13.png';
import book1_14 from '../../assets/images/1_14.png';
import book2_1 from '../../assets/images/2_1.JPG';
import book2_2 from '../../assets/images/2_2.JPG';
import book2_3 from '../../assets/images/2_3.jpg';
import book2_4 from '../../assets/images/2_4.JPG';
import book2_5 from '../../assets/images/2_5.jpg';
import book2_6 from '../../assets/images/2_6.JPG';
import book2_7 from '../../assets/images/2_7.jpg';
import book2_8 from '../../assets/images/2_8.png';
import book2_9 from '../../assets/images/2_9.png';
import book2_10 from '../../assets/images/2_10.png';
import book3_1 from '../../assets/images/3_1.JPG';
import book3_2 from '../../assets/images/3_2.JPG';
import book3_3 from '../../assets/images/3_3.JPG';
import book3_4 from '../../assets/images/3_4.JPG';
import book3_5 from '../../assets/images/3_5.jpg';
import book3_6 from '../../assets/images/3_6.JPG';
import book3_7 from '../../assets/images/3_7.jpg';
import book4_1 from '../../assets/images/4_1.JPG';
import book4_2 from '../../assets/images/4_2.JPG';
import book4_3 from '../../assets/images/4_3.JPG';
import book4_4 from '../../assets/images/4_4.JPG';
import book4_5 from '../../assets/images/4_5.JPG';
import book4_6 from '../../assets/images/4_6.JPG';
import book4_7 from '../../assets/images/4_7.JPG';
import book4_8 from '../../assets/images/4_8.jpg';
import book4_9 from '../../assets/images/4_9.png';
import book4_10 from '../../assets/images/4_10.png';
import book4_11 from '../../assets/images/4_11.png';
import book4_12 from '../../assets/images/4_12.png';
import book5_1 from '../../assets/images/5_1.JPG';
import book5_2 from '../../assets/images/5_2.JPG';
import book5_3 from '../../assets/images/5_3.JPG';
import book5_4 from '../../assets/images/5_4.JPG';
import book6_1 from '../../assets/images/6_1.JPG';
import book6_2 from '../../assets/images/6_2.jpg';
import book6_3 from '../../assets/images/6_3.jpg';
import book6_4 from '../../assets/images/6_4.jpg';
import book6_5 from '../../assets/images/6_5.jpg';
import book6_6 from '../../assets/images/6_6.jpg';
import book6_7 from '../../assets/images/6_7.jpg';
import book6_8 from '../../assets/images/6_8.jpg';
import book6_9 from '../../assets/images/6_9.jpg';

import photo1 from '../../assets/images/photo_1.JPG';
import photo2 from '../../assets/images/photo_2.JPG';
import photo3 from '../../assets/images/photo_3.JPG';
import photo4 from '../../assets/images/photo_4.JPG';
import photo5 from '../../assets/images/photo_5.JPG';
import photo6 from '../../assets/images/photo_6.JPG';

// import { title } from 'framer-motion/client';

const categories = [
  {
    title: '表紙・裏表紙',
    images: [
      book1_1, 
      book1_2, 
      book1_3, 
      book1_4,
      book1_5, 
      book1_6, 
      book1_7, 
      book1_8,
      book1_9, 
      // book1_10, 
      // book1_11,
      book1_12, 
      book1_13, 
      book1_14
    ],
  },
  {
    title: 'あいさつ',
    images: [
      book2_1, 
      book2_2, 
      book2_3, 
      book2_4,
      book2_5, 
      book2_6, 
      book2_7,
      book2_8, 
      book2_9, 
      book2_10,
    ],
  },
  {
    title: 'プロフィール',
    images: [
      book3_1, 
      book3_2, 
      book3_3, 
      book3_4,
      book3_5, 
      book3_6, 
      book3_7,
    ],
  },
  {
    title: 'フリーページ',
    images: [
      book4_1, 
      book4_2, 
      book4_3, 
      book4_4,
      book4_5, 
      book4_6, 
      book4_7,
      book4_8,
      book4_9, 
      book4_10, 
      book4_11,
      book4_12,
    ],
  },
  {
    title: '席次表',
    images: [
      book5_1, 
      book5_2, 
      book5_3, 
      book5_4,
    ],
  },
  {
    title: 'メニュー表（料理・ドリンク）',
    images: [
      book6_1, 
      book6_2, 
      book6_3, 
      book6_4,
      book6_5, 
      book6_6, 
      book6_7,
      book6_8, 
      book6_9,
    ],
  }
];

const Gallery = () => {
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [activeTab, setActiveTab] = useState('profileBook');
  const [modalImage, setModalImage] = useState(null);

  const toggleCategory = (index) => {
    setExpandedCategories((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const openModal = (image) => {
    setModalImage(image);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const renderProfileBook = () => (
    <div className="space-y-8">
      {categories.map((category, index) => (
        <div key={index} className="border border-gray-300 p-4 shadow-md bg-white">
          {/* Category Header */}
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() => toggleCategory(index)}
          >
            <h5 className="text-medium font-bold text-gray-800" style={{ fontFamily: 'zenmaru, serif' }}>
              {category.title}
            </h5>
            <span className="text-gray-500">
              {expandedCategories.includes(index) ? '-' : '+'}
            </span>
          </div>

          {/* Category Images */}
          {expandedCategories.includes(index) && (
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
              {category.images.map((image, imgIndex) => (
                <div key={imgIndex} className="my-8">
                  {/* LazyLoadImage を使用 */}
                  <LazyLoadImage
                    src={image} // 読み込む画像
                    alt={`${category.title} ${imgIndex + 1}`}
                    effect="blur" // ぼかしエフェクト（他に "opacity" なども可）
                    className="w-full h-full object-contain hover:scale-105 transition-transform duration-300 cursor-pointer overflow-hidden border-gray-100 shadow-md hover:shadow-lg"
                    onClick={() => openModal(image)}
                  />
                  <div className="flex justify-center mt-5">
                    <button
                      className="cursor-default px-4 py-2 font-bold border border-gray-400 rounded-full text-sm"
                      style={{ fontFamily: 'Hatton, serif' }}
                    >
                      design &nbsp; {imgIndex + 1}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  const renderWeddingPhoto = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {[photo1, photo2, photo3, photo4, photo5, photo6].map((image, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <image
            src={image}
            alt={`Wedding Photo ${index + 1}`}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
            onClick={() => openModal(image)}
          />
        </div>
      ))}
    </div>
  );

  return (
    <section id="gallery" className="p-6 border-t border-black max-w-4xl mx-auto mt-8 pt-16">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif tracking-wide uppercase" style={{ fontFamily: 'Hatton, serif' }}>
        Gallery
      </h2>

      {/* Toggle Buttons */}
      <div className="flex justify-center space-x-4 mb-8">
        {/* <Button
          label="PROFILE BOOK"
          isActive={activeTab === 'profileBook'}
          onClick={() => setActiveTab('profileBook')}
        /> */}
        {/* <Button
          label="WEDDING PHOTO"
          isActive={activeTab === 'weddingPhoto'}
          onClick={() => setActiveTab('weddingPhoto')}
        /> */}
      </div>

      {/* Conditional Rendering */}
      {activeTab === 'profileBook' && renderProfileBook()}
      {activeTab === 'weddingPhoto' && renderWeddingPhoto()}

      {/* Modal */}
      {modalImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            <LazyLoadImage
              src={modalImage}
              alt="Modal View"
              effect="blur"
              className="max-w-full max-h-screen rounded-lg shadow-lg"
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl font-bold bg-black bg-opacity-50 rounded-full p-2"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;